import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryToolbarComponent } from './tractors-history-toolbar.component';
import {
  DxDateBoxModule,
  DxLoadPanelModule,
  DxSelectBoxModule,
  DxToolbarModule,
  DxValidationGroupModule,
  DxValidatorModule
} from 'devextreme-angular';
import {DxiValidationRuleModule} from 'devextreme-angular/ui/nested';



@NgModule({
  declarations: [TractorsHistoryToolbarComponent],
  imports: [
    CommonModule,
    DxToolbarModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxLoadPanelModule,
    DxValidationGroupModule,
    DxiValidationRuleModule,
    DxValidatorModule
  ],
  exports: [TractorsHistoryToolbarComponent]
})
export class TractorsHistoryToolbarModule { }
